import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Block } from "@block";
import { Paragraph, useTheme } from "react-native-paper";
import { spacing } from "app/shared/styles/spacing";

interface FormAddBeneProps {
  onClick?: Function;
}

const FormViewFee = (props: FormAddBeneProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  const { onClick = () => {} } = props;

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        textLabel: { color: colors.text, fontWeight: "700" },
        textLink: { color: colors.accent, textDecorationLine: "underline" },
      }),
    [colors.accent, colors.text],
  );

  return (
    <Block pv={spacing.medium} row right bottom>
      <Paragraph style={styles.textLabel}>
        {t("FEE_XEM")}:{" "}
        <Paragraph onPress={() => onClick()} style={styles.textLink}>
          {t("FEE_CHI_TIET_PHI")}
        </Paragraph>
      </Paragraph>
    </Block>
  );
};

export default FormViewFee;
